/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContactMessageDto,
  ProblemDetails,
} from '../models/index';
import {
    ContactMessageDtoFromJSON,
    ContactMessageDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface SendContactMessageRequest {
    contactMessageDto: ContactMessageDto;
}

/**
 * 
 */
export class ContactApi extends runtime.BaseAPI {

    /**
     * Send a contact message
     */
    async sendContactMessageRaw(requestParameters: SendContactMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactMessageDto'] == null) {
            throw new runtime.RequiredError(
                'contactMessageDto',
                'Required parameter "contactMessageDto" was null or undefined when calling sendContactMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContactMessageDtoToJSON(requestParameters['contactMessageDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send a contact message
     */
    async sendContactMessage(requestParameters: SendContactMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendContactMessageRaw(requestParameters, initOverrides);
    }

}
